import { render, staticRenderFns } from "./tabelvoucher.vue?vue&type=template&id=6968fe98&"
import script from "./tabelvoucher.vue?vue&type=script&lang=js&"
export * from "./tabelvoucher.vue?vue&type=script&lang=js&"
import style0 from "./tabelvoucher.vue?vue&type=style&index=0&id=6968fe98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports